export default __webpack_public_path__ + "static/media/hog.b0adbfe4.png";